// export const url = "https://zs-dev.firstfloor.site";
export const url = "https://api.zameensquare.com/";
